// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"style__iconWrapper__xL0E6","icon":"style__icon__M0ofb"};